import { ArrayValue, Schema } from '@coveo/bueno';
import { nonEmptyString, requiredNonEmptyString, } from '../../../utils/validate-payload.js';
export const productEnrichmentDefinition = {
    placementIds: new ArrayValue({
        required: false,
        min: 1,
        each: requiredNonEmptyString,
    }),
    productId: nonEmptyString,
};
export const productEnrichmentOptionsSchema = new Schema(productEnrichmentDefinition);
